export const odluka_upucivanje = {
    templateId: 29.4,
    category: 3,
    templateTitle: 'Odluka o upućivanju na rad u inozemstvo (službeni put ne duži od 30 dana)',
    templateDescription: `<p>Ukoliko se radnika upućuje na obavljanje posla u inozemstvo na period kraći od 30 dana, tada nije potrebno sklapati poseban ugovor o radu te se takav rad smatra službenim putom. </p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Upućeni radnik je radnik koji u ograničenom vremenskom razdoblju obavlja svoj posao na državnom području države koja nije država u kojoj uobičajeno radi.    </p>
    <p>Službenim putovanjem u inozemstvo u smislu Zakona o porezu na dohodak i Pravilnika o porezu na dohodak smatra se službeno putovanje do 30 dana (dakle, kraće od 31 dan) neprekidno iz Republike Hrvatske u stranu državu i obratno te putovanje iz jedne strane države u drugu i iz jednog mjesta u drugo mjesto na teritoriju strane države.    </p>
    <p>Ukoliko se radnika upućuje na rad u inozemstvo u neprekidnom trajanju <strong>dužem</strong> od 30 dana, pisani ugovor o radu odnosno pisana potvrda o sklopljenom ugovoru o radu prije upućivanja na rad u inozemstvo mora  sadržavati odredbe o:</p>
    <p>1) trajanju rada u inozemstvu,</p>
    <p>2) rasporedu radnog vremena,</p>
    <p>3) neradnim danima i blagdanima u koje radnik ima pravo ne raditi uz naknadu plaće,</p>
    <p>4) novčanoj jedinici u kojoj će se isplaćivati plaća,</p>
    <p>5) drugim primanjima u novcu i naravi na koja će radnik imati pravo za vrijeme rada u inozemstvu,</p>
    <p>6) uvjetima vraćanja u zemlju.</p>
    
    <p>Dakle, za  upućivanju/izaslanje radnika na rad u inozemstvo na razdoblje kraće od 31 dan, nije potrebno sklapati ugovor o radu te se isti u smislu poreznih propisa Republike Hrvatske smatra službenim putom.</p>
    <p>Tako određuje u Zakon o doprinosima, gdje se navodi da je službeni put u inozemstvo jest boravak osiguranika u inozemstvu po nalogu poslodavca ili isplatitelja primitka od kojeg se utvrđuje drugi dohodak, ili po potrebi samostalne djelatnosti u trajanju do 30 dana neprekidno.   </p>
  
    <h5>PRAVNA OSNOVA</h5>
    <p>Zakon o radu, Zakon o porezu na dohodak, Pravilnik o porezu na dohodak, Zakon o doprinosima.</p>
  `,
    
    sides: [
        {
            prefix: 'Na temelju Zakona o radu,',
            signature: 'Za Poslodavca:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Poslodavac),',
        }
    ],

    headline: 'donosi sljedeću',
    title: 'ODLUKU O UPUĆIVANJU NA RAD U INOZEMSTVO',
    noArticleNumbers: true,
    
    articles: [
      {
          mandatory: true,
          statements: [
              {
                  title: '',
                  type: 'input',
                  mandatory: true,
                  editable: true,
                  parts: [
                      {type: 'text', content: 'Radnik'},
                      { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
                      { type: "text", content: "," },
                      { type: 'text', content: 'iz',},
                      { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
                      { type: 'text', content: ',' },
                      { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
                      { type: "text", content: "," },
                      { type: 'text', content: 'OIB:' },
                      {type: 'input', value: '', required: true},
                      {type: 'text', content: '(u daljnjem tekstu: Radnik),'},
                      {type: 'input', value: '', required: true},
                      {type: 'text', content: 'trenutno se nalazi u radnom odnosu kod Poslodavca.'},
                  ],
                  value: '',
              },
          ],
      },
      {
        mandatory: true,
        exampleContent: true,
        statements: [
            {
                title: '',
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Radnika se upućuje na rad u ___________________ , temeljem Ugovora između Poslodavca i _____________________, u trajanju kraćem od 30 dana, točnije od __.__.20__. godine do __.__.20__. godine.',
                value: '',
            }],
    },

        {
          mandatory: true,
          exampleContent: true,
          statements: [
              {
                  title: '',
                  type: 'text',
                  mandatory: true,
                  editable: true,
                  content: 'Imenovani ostvaruje pravo na naknadu troškova smještaja u ____________ te ostala prava koja mu pripadaju temeljem Ugovora o radu odnosno drugih Odluka, propisa, Pravilnika i sl..',
                  value: '',
              }],
      },
      
      {
        title: "",
        mandatory: true,
        statements: [
          {
            type: "text",
            mandatory: true,
            editable: true,
            content: "Ova Odluka stupa na snagu danom donošenja."
          }]
      },
      // {
      //   title: "NAPUTAK O ZAŠTITI PRAVA",
      //   mandatory: true,
      //   dummy: true,
      //   statements: [
      //     {
      //       type: "text",
      //       mandatory: true,
      //       editable: false,
      //       content: "Protiv ove Odluke Radnik može Poslodavcu podnijeti zahtjev radi zaštite svojih prava, u roku od 15 dana od dana dostave ove Odluke."
      //     }]
      // },
      {
          mandatory: true,
          static: true,
          type: 2, // date and place
          statements: [
            {
              type: "input",
              mandatory: true,
              parts: [
                {
                  type: "text",
                  content: "U"
                },
                {
                  type: "input",
                  value: "",
                  placeholder: "Upišite mjesto.",
                  required: true,
                },
                {
                  type: "text",
                  content: ", dana"
                },
                {
                  type: "date",
                  value: new Date(),
                  required: true
                },
                {
                  type: "text",
                  content: "godine."
                }
              ]
            },
          ]
        },
      {
          mandatory: true,
          static: true,
          type: 3,  // signatures
          statements: [],
        },
        {
          static: true,
          mandatory: false,
          type: 4, 
          statements: [
            {
              type: 'text',
              mandatory: true,
              editable: true,
              content: 'Dostaviti:\r\n1) Radniku\r\n2) Kadrovska služba',
              help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
            }
          ]
        },
        {
          static: true,
          mandatory: true,
          type: 4, 
          statements: [
            {
              type: 'text',
              mandatory: true,
              editable: true,
              help: 'Ako postupak dostave nije uređen kol. ug., sporazumom između radničkog vijeća i poslodavca ili pravilnikom o radu, primjenjuju se odredbe o dostavi određene parničnim postupkom. U tom slučaju, otkaz se može dostaviti prep. pošt. pošiljkom s povr. ili osobno, na radnom mjestu, no ukoliko radnik odbija primiti odluku, navedeno odbijanje može se pisano konstatirati uz potpis dva svjedoka. Otkaz se može dostaviti i putem j. bilježnika.',
              content: 'Potvrđujem primitak Odluke dana _______________ godine.\r\n\r\nPotpis Radnika: ____________________\r\n\r\n',
            },
          ]
        },
      ],
    };
    


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/29.4_odluka_upucivanje.ts